/**
 * CSV アップロード共通基盤の入口拒否上限 (bytes)。50 MB。
 *
 * backend の protovalidate `CheckDemandGroupCsvRequest.csv_content` の
 * `max_len = 52428800` (demand-groups-upload-tracer 設計書 §3 #6) と同値。
 * frontend の DropZone はこの定数でサーバー呼び出し前にファイルサイズを
 * 拒否する (AC-06)。ズレを防ぐため単一定数として共有し、csvUpload.test.ts
 * でバックエンドの max_len 値との同値を assert する。
 */
export const MAX_CSV_FILE_SIZE_BYTES = 52_428_800

/**
 * 入札 CSV (通常入札・ブロック入札、 SpotCsvImport が両方に使う) の入口拒否
 * 上限 (bytes)。20 MB。
 *
 * backend の protovalidate `CheckBiddingSpotNormalCsvRequest.csv_content` /
 * `CheckBiddingBlockCsvRequest.csv_content` の `max_len = 20971520`
 * (docs/specs/admin/data/uploads/common.md「CSV アップロードの上限はファイル
 * サイズ（20 MB）のみとし…」2026-09-25 PdM 決定) と同値。 他データ種別が使う
 * MAX_CSV_FILE_SIZE_BYTES (50 MB) とは別値 — 入札 CSV の spec だけ 20 MB を
 * 明示しているため、 共通定数を変えず専用定数を切る。
 */
export const MAX_BID_CSV_FILE_SIZE_BYTES = 20_971_520

/**
 * 顧客契約 CSV の入口拒否上限 (bytes)。20 MB。
 *
 * backend の protovalidate `ImportCustomerContractsRequest.content` の `max_len = 20971520`
 * (docs/specs/admin/data/uploads/common.md「CSV アップロードの上限はファイルサイズ（20 MB）のみ…」、
 * customer-contract.md 非機能要件) と同値。 行数の上限は設けない。
 */
export const MAX_CUSTOMER_CONTRACT_CSV_FILE_SIZE_BYTES = 20_971_520

/**
 * CSV アップロード共通基盤のデータ行数上限。10 万行。
 *
 * backend usecase/demandgroup の maxCsvRows (demand-groups-upload-tracer
 * 設計書 §3 #6 / AC-06) と同値。frontend では行数検証はしない (検証は
 * サーバー側チェックが担う) — この定数は Step1 のガイダンス表示にのみ使う。
 */
export const MAX_CSV_ROW_COUNT = 100_000
